import { render } from "./range-age-donut.vue?vue&type=template&id=dc644ab2"
import script from "./range-age-donut.vue?vue&type=script&lang=js"
export * from "./range-age-donut.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__